import React, { useState } from 'react';
import { Button, DatePicker, Form, Modal, Space } from 'antd';
import { translate } from '../../core';
import { Combo, StimulsoftViewer } from '../../core/component';
import { standardFormat } from '../../core/until';
import { getItemTypeComboOptions } from '../inventory/func/type-options';
import { BackOrderReportRequest, ItemType } from '../inventory/type';
import { Dayjs } from 'dayjs'
import { VendorSelect } from '../contact/component/VendorSelect'

type BackOrderReportForm = Omit<BackOrderReportRequest, 'minDate' | 'maxDate'> & {
  date?: [Dayjs, Dayjs]
}

export const BackOrderReport = () => {
  const [form] = Form.useForm<BackOrderReportForm>();
  const [request, setRequest] = useState<BackOrderReportRequest>()
  const [confirmModalVisible, setConfirmModalVisible] = useState(false);

  const isFormValid = async (): Promise<boolean> => {
    try {
      await form.validateFields({validateOnly: true});
      return true;
    } catch {
      return false;
    }
  };

  const handleOK = async () => {
    if (await isFormValid()) {
      setConfirmModalVisible(false);
    }
    form.submit();
  };

  return (
    <>
      <Button
        type='primary'
        onClick={() => setConfirmModalVisible(true)}
        className='btn-primary-gradient'
      >
        {translate('new_report')}
      </Button>
      <div className='print-hidden'>
        <StimulsoftViewer name='back-order' request={request} skip={!request}/>
      </div>
      <Modal
        open={confirmModalVisible}
        onCancel={() => setConfirmModalVisible(false)}
        onOk={handleOK}
        okText={translate('get_report')}
        cancelText={translate('cancel')}
        width={600}
        footer={<Space>
          <Button
            onClick={() => setConfirmModalVisible(false)}
          >
            {translate('cancel')}
          </Button>

          <Button
            onClick={() => form.resetFields()}
          >
            {translate('clear')}
          </Button>

          <Button
            type='primary'
            onClick={handleOK}
          >
            {translate('get_report')}
          </Button>

        </Space>}
      >
        <Form
          layout='vertical'
          form={form}
          onFinish={data =>{
            const [minDate, maxDate] = data.date ?? []
            setRequest({
              type: data.type,
              vendorId: data.vendorId,
              minDate: minDate?.format(standardFormat),
              maxDate: maxDate?.format(standardFormat),
            })
          }}
        >
          <Form.Item
            name='type'
            label={translate('type')}
          >
            <Combo<any, ItemType>
              allowMultiple
              size='middle'
              options={getItemTypeComboOptions()}
            />
          </Form.Item>

          <Form.Item
            name='vendorId'
            label={translate('vendor')}
          >
            <VendorSelect
              mode='multiple'
            />
          </Form.Item>

          <Form.Item
            name='date'
            label={translate('date')}
          >
            <DatePicker.RangePicker
              className='w-100'
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
